module.exports = __webpack_public_path__ + "static/icons-f266c0f53b88c262812e55fbc2b7de24.png";